import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotLock = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M28.073 25.379c-3.875-4.183-13.256-6.877-16.79-.922-1.414 2.39-1.902 6.909-.202 9.26 1.7 2.352 5.188 2.721 7.966 2.232-.76 1.906.159 4.506 2.791 4.328 6.534-.445 10.853-9.915 6.235-14.898Z"
                opacity={0.75}
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="M14.787 6.374a7.338 7.338 0 0 1 12.526 5.189v5.65H12.638v-5.65c0-1.946.773-3.812 2.15-5.189Zm14.726 5.189v5.65h2.274a4.475 4.475 0 0 1 4.476 4.475c0 1.085-.455 5.085-2.685 8.853-2.274 3.842-6.402 7.435-13.603 7.435-7.2 0-11.33-3.593-13.603-7.435-2.23-3.768-2.684-7.768-2.684-8.853a4.475 4.475 0 0 1 4.474-4.475h2.276v-5.65a9.537 9.537 0 1 1 19.075 0ZM5.887 21.688a2.275 2.275 0 0 1 2.276-2.275h23.624a2.275 2.275 0 0 1 2.276 2.275c0 .78-.39 4.373-2.378 7.733-1.945 3.286-5.41 6.355-11.71 6.355-6.3 0-9.765-3.069-11.71-6.355-1.988-3.36-2.378-6.954-2.378-7.733Zm12.105 3.065a2.088 2.088 0 0 1 2.617-1.272 2.088 2.088 0 0 1 .188 3.925v2.599a.804.804 0 0 1-1.608 0v-2.6a2.088 2.088 0 0 1-1.197-2.652Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotLock.displayName = "SpotLock";
